import React, { useEffect,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { initialFormData, initialErrors, fieldValidation  } from '../../../common/helper/form-constants.js';


const AddApiKey = (props) => {
  const [formData, setFormData] = useState({key_id:'', secret: '' });
  const [errors, setErrors] = useState({ ...initialErrors });

  const generateRandomString = (number) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < number; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage
  };
  const onSave = (e) => {
    e.preventDefault();
    let hasErrors;
    Object.keys(formData).forEach(fieldName => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
          hasErrors = true;
      }
  });
  if(!hasErrors) {
    props.onSubmit(formData);
  }
   
  }
  const downloadKey = () => {
    const csvData = [
        Object.keys(formData).join(','), // Headers
        Object.values(formData).join(',') // Values
    ].join('\n');
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'keys.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
  useEffect(() => {
  
        setFormData({
          key_id: generateRandomString(15),
          secret: generateRandomString(25)
        })

      }, []); 
    return (
      <>
  
       <Modal  {...props}>
        <Modal.Header closeButton>
          <Modal.Title>Create New Api Key</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form action="#" method="post" >
        <div className="form-group" style={{textAlign: 'left'}}>
          <label htmlFor="keyid">Key Id</label>
          <input type="text" className={`form-control ${errors.key_id ? 'is-invalid' : ''}`}  id="key_id" placeholder="Enter Key Id" name="key_id" value={formData.key_id}  onChange={handleChange} disabled/>
          {errors.key_id && <div className="invalid-feedback">{errors.key_id}</div>}
        </div>
        <div className="form-group" style={{textAlign: 'left'}}>
          <label htmlFor="keysecret">Key Secret</label>
          <input type="text" className={`form-control ${errors.secret ? 'is-invalid' : ''}`}  id="key_secret" value={formData.secret} placeholder="Enter Key Secret" name="key_secret"  onChange={handleChange} disabled/>
          {errors.secret && <div className="invalid-feedback">{errors.secret}</div>}
        </div>
        <div className="form-group " style={{textAlign: 'left', marginBottom: 0}} onClick={downloadKey}>
          <span onclick="download_csv_file()" className="btn btn-success ddfg cdxs regentrae-key" style={{color: '#3280dd!important', backgroundColor: 'white!important', border: '1px solid #65c5ff', fontSize: '12px'}}>
            <i className="fa fa-download" style={{color: '#3280dd', marginRight: '7px'}} /> Download Key Details </span>
        </div>
       </form>
  
            
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Sumbit
          </Button>
        </Modal.Footer>
       
      </Modal>
  
      </>
    );
  }
  


  export default AddApiKey;



